import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import img from '../components/images/expo360.jpg';
import img2 from '../components/images/What360.jpg';
import img3 from "../components/images/logo360.png";

import './Page360.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

/* section 7*/
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Carousel360 from '../components/carousel';

import Footer from '../components/Footer';




function Page360() {
  const { t, i18n } = useTranslation();
  /* هي الدالة قبل الريترن لحتى عند الانتقال للصفحة تبلش من الاول */
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* السكشن الأول - معرض 360 */}
      <section className="page360-section">
        <div
          className="page360-background"
          style={{ backgroundImage: `url(${img})` }}
        ></div>

        <div className="page360-container">
          <div className="page360-content">

            <h1 className="page360-heading">
              {i18n.language !== 'ar' && <img src={img3} alt="Logo 360" className="page360-logo" />}
              <span className="page360-heading-360">{t('Page360.HeroTitle')}</span>
              {i18n.language === 'ar' && <img src={img3} alt="Logo 360" className="page360-logo" />}
            </h1>

            <div className="page360-box-green">
              <h2>{t('Page360.HeroSubtitle1')}</h2>
            </div>

            <div className="page360-box-blue">
              <p>{t('Page360.HeroSubtitle2')}</p>
            </div>

          </div>
        </div>
      </section>
      {/* end section 1 */}


      {/* السكشن الثاني - ماهو معرض 360 */}
      <section className="whatis360-section ">
        <div
          className="whatis360-background"
          style={{
            backgroundImage: `url(${img2})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            minHeight: "100vh",
          }}>
        </div>

        <div className="whatis360-container">
          <div className="whatis360-header">
            <h1 className="whatis360-title">
              <span className="whatis360-title">{t('Page360.WhatIsTitleBefore')} </span>
              <img src={img3} alt="Logo 360" className="page360-logo3" />
              <span className="whatis360-title">{t('Page360.WhatIsTitleAfter')} </span>
            </h1>
          </div>

          <div className="whatis360-content">

            <div className="whatis360-box whatis360-box-left">
              <p>
                {t('Page360.WhatIsContentLeft')}
              </p>
            </div>

            {/* السهم بين المربعين */}
            <div className="whatis360-arrow">
              <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
                <path d="M10 30 L40 30 M40 30 L30 20 M40 30 L30 40" stroke="#2d9b6f" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>


            <div className="whatis360-box whatis360-box-right">
              <div className="whatis360-question-mark">{i18n.language === 'ar' ? '؟' : '?'}</div>
              <p>
                {t('Page360.WhatIsContentRight')}
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* end section 2 */}

      {/* السكشن الرابع - اهداف 360 */}
      <section id="section4"
        className="text-center py-5"
        style={{
          backgroundImage: `url(${img2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh",
        }}
      >
        <div className="container">
          <h2 className="aboutus-title mb-5 mt-5 text-center">
            {i18n.language !== 'ar' && <img src={img3} alt="Logo 360" className="page360-logo3" />}
            <span className="whatis360-title">{t('Page360.GoalsTitle')}</span>
            {i18n.language === 'ar' && <img src={img3} alt="Logo 360" className="page360-logo3" />}
          </h2>

          {/* Wrapper للصورة والكروت */}
          <div className="position-relative mx-auto" style={{ maxWidth: "455px" }}>
            {/* الصورة */}
            <img
              src="/img/99.JPG"
              className="img-fluid"
              style={{ display: "block", width: "100%", height: "auto" }}
              alt="الأهداف"
            />

            {/* الكرت الأول */}
            <div
              className="position-absolute bg-white p-2 rounded shadow"
              style={{
                top: "22%",
                left: "-11%",
                width: "320px",
              }}
            >
              <p className="mb-0" style={{ textAlign: i18n.language === 'ar' ? 'right' : 'left', direction: i18n.language === 'ar' ? 'rtl' : 'ltr' }}>
                <span className="fw-bold">{t('Page360.Goal1Title')}</span> {t('Page360.Goal1Text')}
              </p>
            </div>

            {/* الكرت الثاني */}
            <div
              className="position-absolute bg-white p-2 rounded shadow"
              style={{
                top: "41%",
                left: "42%",
                width: "320px",
              }}

            >
              <p className="mb-0" style={{ textAlign: i18n.language === 'ar' ? 'right' : 'left', direction: i18n.language === 'ar' ? 'rtl' : 'ltr' }}>
                <span className="fw-bold">{t('Page360.Goal2Title')}</span> {t('Page360.Goal2Text')}
              </p>
            </div>

            {/* الكرت الثالث */}
            <div
              className="position-absolute bg-white p-2 rounded shadow"
              style={{
                top: "60%",
                left: "-11%",
                width: "320px",
              }}
            >
              <p className="mb-0" style={{ textAlign: i18n.language === 'ar' ? 'right' : 'left', direction: i18n.language === 'ar' ? 'rtl' : 'ltr' }}>
                <span className="fw-bold">{t('Page360.Goal3Title')}</span> {t('Page360.Goal3Text')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* السكشن الثالث - لمن معرض 360 */}
      <section id="section3"
        className="text-center py-5 "
        style={{
          backgroundImage: `url(${img2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh",
        }}>

        <div className="container">


          <h2 className="aboutus-title mb-5 mt-4 text-center">
            <span className="whatis360-title">
              {t('Page360.TargetAudienceTitleBefore')}
              <img src={img3} alt="Logo 360" className="page360-logo3" />
              {t('Page360.TargetAudienceTitleAfter')}
            </span>
          </h2>


          <br></br> <br></br> <br></br> <br></br>
          <div className="row justify-content-center g-4">
            {[
              { text: t('Page360.Audience1') },
              { text: t('Page360.Audience2') },
              { text: t('Page360.Audience3') },
            ].map((item, index) => (
              <div key={index} className="col-md-3 col-sm-10">
                <div className="card aboutus-card h-100 text-center">
                  <div className="card-body d-flex flex-column justify-content-center align-items-center">

                    <p>{item.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </section>




      {/* السكشن السادس - معلومات حضور 360 */}
      <section className="whatis360-section  ">
        {/* خلفية السكشن */}
        <div
          className="whatis360-background"
          style={{
            backgroundImage: `url(${img2})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            minHeight: "100vh",
          }}>
        </div>
        <div className="whatis360-container">
          <div className="whatis360-headerr">
            <div className="whatis360-header-content">
              <h1 className="whatis360-title">
                {i18n.language !== 'ar' && <img src={img3} alt="Logo 360" className="page360-logo4" />}
                <span className="whatis360-title-text">{t('Page360.AttendInfoTitle')}</span>
                {i18n.language === 'ar' && <img src={img3} alt="Logo 360" className="page360-logo4" />}
              </h1>

              <div className="whatis360-cards-container">
                <div className="whatis360-card whatis360-first">
                  {t('Page360.AttendFirst')}
                </div>

                <div className="whatis360-card whatis360-second">
                  {t('Page360.AttendSecond').split('\n').map((line, i) => (
                    <React.Fragment key={i}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                </div>
              </div>

              <div className="text-center mt-5">
                <button className="join-btnn d-flex align-items-center fw-bold px-4 py-2 rounded-pill mx-auto">
                  <span className="me-2">{t('Page360.RegisterNow')}</span>
                  <i className="bi bi-hand-index-thumb-fill sparkle"></i>
                </button>
              </div>
            </div>
          </div>
        </div>


      </section>

      {/* start secion 7 */}
      {/* السكشن السابع - معرض الصور 360 */}
      <section className="awaits360-section" style={{
        backgroundImage: `url(${img2})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
      }}>
        {/* Background */}


        {/* Content Container */}
        <div className="awaits360-container">
          {/* Header Box */}
          <div className="awaits360-header-box">
            <h1 className="awaits360-title">
              <span>{t('Page360.AwaitsTitleBefore')} </span>
              <img src={img3} alt="Logo 360" className="page360-logo2" />
              <span>{t('Page360.AwaitsTitleAfter')}</span>
            </h1>
          </div>

          {/* Timeline */}
          <div className="awaits360-timeline-wrapper">
            <div className="awaits360-timeline">
              {/* Item 4 - الرابع فوق */}
              <div className="awaits360-item-container">
                <div className="awaits360-item awaits360-top">
                  <div className="awaits360-text">
                    <p>{t('Page360.Awaits4Title')}</p>
                    <p>{t('Page360.Awaits4Text')}</p>
                  </div>
                  <div className="awaits360-connector-v"></div>
                  <div className="awaits360-circle">4</div>
                </div>
              </div>

              <div className="awaits360-connector-h"></div>

              {/* Item 3 - الثالث تحت */}
              <div className="awaits360-item-container">
                <div className="awaits360-item awaits360-bottom">
                  <div className="awaits360-circle">3</div>
                  <div className="awaits360-connector-v"></div>
                  <div className="awaits360-text">
                    <p>{t('Page360.Awaits3Title')} </p>
                    <p>{t('Page360.Awaits3Text')}</p>
                  </div>
                </div>
              </div>

              <div className="awaits360-connector-h"></div>

              {/* Item 2 - الثاني فوق */}
              <div className="awaits360-item-container">
                <div className="awaits360-item awaits360-top">
                  <div className="awaits360-text">
                    <p>{t('Page360.Awaits2Title')}</p>

                  </div>
                  <div className="awaits360-connector-v"></div>
                  <div className="awaits360-circle">2</div>
                </div>
              </div>

              <div className="awaits360-connector-h"></div>

              {/* Item 1 - الأول تحت */}
              <div className="awaits360-item-container">
                <div className="awaits360-item awaits360-bottom">
                  <div className="awaits360-circle">1</div>
                  <div className="awaits360-connector-v"></div>
                  <div className="awaits360-text">
                    <p>{t('Page360.Awaits1Title')}</p>
                    <p>{t('Page360.Awaits1Text')}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* end section 7}

       {/* section 8}
      {/* section corusel */}


      {/* end section 8*/}
      <Footer />
    </>
  );
}

export default Page360;